export default __webpack_public_path__ + "static/media/10464412.5f159a33.png";